export default {
  validate: {
    method: 'post',
    url: '/order/allotment/validate/ORDER_ID'
  },
  add: {
    method: 'post',
    url: '/order/allotment/ORDER_ID'
  },
  addVendor: {
    method: 'post',
    url: '/order/allotment/ORDER_ID/add-vendor'
  }
}
